let config = {};

if (process.env.NODE_ENV === 'production') {
  config.apiEndpoint = '//arcane-waters-47693.herokuapp.com/api/v1';
  config.apiBase = '//arcane-waters-47693.herokuapp.com';
} else if (process.env.NODE_ENV === 'staging') {
  config.apiEndpoint = '//enigmatic-escarpment-74516.herokuapp.com/api/v1';
  config.apiBase = '//enigmatic-escarpment-74516.herokuapp.com';
} else {
  config.apiEndpoint = '//localhost:3000/api/v1';
  config.apiBase = '//localhost:3000';
}

const Config = Object.assign({}, config);

export default Config;



/** WEBPACK FOOTER **
 ** ./Config.js
 **/